export const currencyTextFormat: (monto: string | null, currency?: 'CL' | 'PE' | 'MX') => string = (monto, currency = 'CL') => {
  const currencyData = { CL: { format: 'es-CL', currency: 'CLP' }, PE: { format: 'es-PE', currency: 'PEN' }, MX: { format: 'es-MX', currency: 'MEX' } }

  if (!monto) return ''
  const cleanMonto = monto.replace(/[^\d.-]/g, '')
  const numberMonto = Number(cleanMonto)
  if (isNaN(numberMonto)) return ''
  const { format, currency: currencyCode } = currencyData[currency]
  return numberMonto.toLocaleString(format, { style: 'currency', currency: currencyCode })
}
